module.exports = __webpack_public_path__ + "img/icon_footer_hkfs_unselect.a3ec90e9.png";